import React, {Component} from 'react';
import {connect} from 'react-redux';
import NumberHelper from "helpers/number-helper";
import Action from 'components/organisms/nhl-legacy-team-stacking/actions';
import {resolveExposuresOverlap} from 'helpers/exposure';

class CombinationExposure extends Component {
    constructor(props) {
        super(props);
        const {stacking, exposureType, comboKey} = props;
        this.exposureType = exposureType;
        this.limitValue = 'min' === this.exposureType ? 0 : 100;
        this.isValueBeingChanged = false;
        this.state = {
            value: stacking.getCombinationExposure(comboKey, exposureType),
        };
    }
    onChange(value) {
        this.isValueBeingChanged = true;
        this.setState({value});
    }
    onBlur(value) {
        const exposure = this.normalizeExposures(value);

        this.setState({value: exposure});

        this.isValueBeingChanged = false;

        this.props.dispatch(Action.setCombinationExposure(
            this.props.comboKey,
            exposure,
        ));
    }
    normalizeExposures(value) {
        const {stacking, comboKey} = this.props;
        const exposure = {
            min: stacking.getCombinationMinExposureValue(comboKey),
            max: stacking.getCombinationMaxExposureValue(comboKey)
        };
        exposure[this.exposureType] = NumberHelper
            .prepareInt(value, this.limitValue)
            .limitByRange(0, 100, 0, 100)
            .get();

        return resolveExposuresOverlap(
            exposure,
            this.exposureType,
        );
    }
    getActualValue() {
        let value = this.state.value;

        if (!this.isValueBeingChanged) {
            const {stacking, comboKey, exposureType} = this.props;
            value = stacking.getCombinationExposure(comboKey, exposureType);
        }

        return value;
    }
    render() {
        const {className = "form-control"} = this.props;
        const exposure = this.getActualValue();

        return (
            <input
                onBlur={e => ::this.onBlur(e.target.value)}
                onChange={e => ::this.onChange(e.target.value)}
                value={`${exposure}`}
                type="number"
                className={className}/>
        );
    }
}

function mapStatesToProps(state) {
    const {
        nhlLegacyTeamStacking,
    } = state;

    return {
        stacking: nhlLegacyTeamStacking,
    }
}

export default connect(mapStatesToProps)(CombinationExposure);
